import { AvailabilityOrder } from '@libs/trip-planner-interfaces';
import type {
  DecimalRangeType,
  StringRangeType,
} from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';
import type { TransportIngredientType } from './typeGuards';

export interface TransportIngredientFilters {
  carrierFilters: string[];
  departureTimeFilters?: StringRangeType;
  arrivalTimeFilters?: StringRangeType;
  maxDurationInHours?: number;
  priceFilters?: DecimalRangeType;
}

export const DEFAULT_AVAILABILITY_ORDER_SUGGESTION = AvailabilityOrder.Popular;

export class TransportIngredient<
  T extends TransportIngredientType = TransportIngredientType
> extends BaseIngredient<T> {
  public static get defaultFilters(): TransportIngredientFilters {
    return {
      carrierFilters: [],
      arrivalTimeFilters: undefined,
      departureTimeFilters: undefined,
      maxDurationInHours: undefined,
      priceFilters: undefined,
    };
  }

  public isManuallySelected = false;
  public isConfirmed = false;

  public transportIds?: string[];

  public fromPortDisplayText?: string;
  public toPortDisplayText?: string;
  public fromPort?: string;
  public toPort?: string;
  public fromPortText?: string;
  public toPortText?: string;

  public filters: TransportIngredientFilters =
    TransportIngredient.defaultFilters;

  public availabilityOrder: AvailabilityOrder =
    DEFAULT_AVAILABILITY_ORDER_SUGGESTION;

  constructor(public readonly ingredientType: T) {
    super(ingredientType);
  }

  public isIngredientCorrect(): boolean {
    return !!this.fromPort && !!this.toPort;
  }
}
